import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominaSaIngreso', {
    template: template,
    controller: NominaSaIngresoComponent,
    bindings: {
      idProyecto: '<',
      idNomina: '<',
    },
  })

function NominaSaIngresoComponent(NominaSaIngreso) {
  let $ctrl = this

  $ctrl.$onInit = $onInit
  $ctrl.cargando = false
  $ctrl.cargar = cargar
  $ctrl.parcial = 'completo'

  function $onInit() {
    cargar()
  }

  function cargar() {
    $ctrl.cargando = true

    $ctrl.promise = NominaSaIngreso.get($ctrl.idProyecto, $ctrl.idNomina, $ctrl.parcial)
      .then(function (response) {
        $ctrl.data = response.data
      })
      .finally(function () {
        $ctrl.cargando = false
      })
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/sa/ingreso/component.js